<template>
  <!-- 搜索 -->
  <div ref="topDom" class="header-bar">
    <div class="bar-lef"></div>
    <div class="bar-rig">
      <div class="rig-one">
        <a-input-search v-model:value="searchForm.store_name" :loading="searchLoading" placeholder="请输入门店名称" @search="getTableList"> </a-input-search>
      </div>
      <div class="rig-group">
        <div class="group-one">
          <a-select v-model:value="searchForm.status" placeholder="状态" @change="getTableList()">
            <a-select-option :value="0">全部</a-select-option>
            <a-select-option :value="1">开业</a-select-option>
            <a-select-option :value="2">停业</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="rig-one-no-shadow">
        <a-button type="link" @click="handleReset">重置筛选</a-button>
      </div>
    </div>
  </div>

  <!-- 表格 -->
  <a-table
    :columns="columns"
    :dataSource="dataSource"
    :loading="searchLoading"
    :pagination="false"
    :scroll="{ x: columns.length > 8 ? columns.length * 130 : 0, y: tableHeight }"
    class="table"
    size="small"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key == 'cancelState'">
        <div v-if="record.cancelState == 0">正常</div>
        <div v-else>注销</div>
      </template>
      <template v-if="column.key == 'operate'">
        <a-button v-if="record.cancelState != 1" type="link" @click="openDetails(record, 2)">编辑</a-button>
        <a-button type="link" @click="openDetails(record, 1)">查看</a-button>
        <a-button v-if="record.status == 0 || record.status == 3" type="link" @click="operSyn(record)">同步上报 </a-button>
        <a-button v-if="record.cancelState == 0" class="f-c-red" type="link" @click="cancel(record)">注销 </a-button>
      </template>
    </template>
  </a-table>

  <!-- 分页 -->
  <MyPagination :pageTotal="pageTotal" @onShowSizeChange="onShowSizeChange" @pageChange="pageChange" />

  <!-- 门店弹窗 -->
  <a-modal v-model:visible="visibleAdd" :title="formTitle" :width="'80%'" class="modal" @ok="confirmFun">
    <a-form ref="formRef" :label-col="{ span: 8 }" :model="addForm" :rules="rules">
      <a-row :gutter="24" class="row-box">
        <a-col :span="8">
          <a-form-item v-if="addForm.id" class="f-item" label="门店ID" name="store_name">
            <div v-if="isLook">{{ addForm.id }}</div>
            <a-input v-else v-model:value="addForm.id" disabled />
          </a-form-item>
          <a-form-item v-if="addForm.hotelCode" class="f-item" label="商户编码" name="hotelCode">
            <div>{{ addForm.hotelCode }}</div>
          </a-form-item>
          <a-form-item v-if="addForm.cancelState" class="f-item" label="经营状态" name="cancelState">
            <div v-if="isLook">{{ addForm.cancelState == 0 ? '开业' : '停业' }}</div>
            <a-radio-group v-else v-model:value="addForm.cancelState">
              <a-radio :value="0">开业</a-radio>
              <a-radio :value="1">停业</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item class="f-item" label="门店名称" name="realName">
            <div v-if="isLook">{{ addForm.realName }}</div>
            <a-input v-else v-model:value="addForm.realName" placeholder="请输入门店名称" />
          </a-form-item>
          <a-form-item class="f-item" label="所属派出所：">
            <div v-if="isLook">{{ addForm.policeAreaName }}</div>
            <StationSelect v-else :class="{ areaSel: addForm.id }" :placeholder="stationPlaceholder" style="width: 100%" @changeStation="changeStation" />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item class="f-item" label="营业执照名称" name="hotelName">
            <div v-if="isLook">{{ addForm.hotelName }}</div>
            <a-input v-else v-model:value="addForm.hotelName" :min="0" placeholder="请输入企业信用代码" style="width: 100%" />
          </a-form-item>
          <a-form-item class="f-item" label="营业执照编号" name="businessLicense">
            <div v-if="isLook">{{ addForm.businessLicense }}</div>
            <a-input v-else v-model:value="addForm.businessLicense" :min="0" placeholder="请输入企业信用代码" style="width: 100%" />
          </a-form-item>
          <a-form-item class="f-item" label="房间数" name="houseNum">
            <div v-if="isLook">{{ addForm.houseNum }}</div>
            <a-input-number v-else v-model:value="addForm.houseNum" :min="0" placeholder="请输入房间数" style="width: 100%" />
          </a-form-item>
          <a-form-item class="f-item" label="统一房源地址" name="ty_roomAddress">
            <div v-if="isLook">{{ addForm.ty_roomAddress }}</div>
            <a-input v-else v-model:value="addForm.ty_roomAddress" placeholder="请输入统一房源地址" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item class="f-item" label="所在区域：">
            <div v-if="isLook">{{ addForm.province_name }} / {{ addForm.city_name }} / {{ addForm.area_name }}</div>
            <AreaSelect v-else :class="{ areaSel: addForm.id }" :placeholder="areaPlaceholder" style="width: 100%" @changeArea="changeArea" />
          </a-form-item>
          <a-form-item class="f-item" label="门店地址" name="hotelAddress">
            <div v-if="isLook">{{ addForm.hotelAddress }}</div>
            <a-textarea v-else v-model:value="addForm.hotelAddress" placeholder="请输入门店详细地址" />
          </a-form-item>
          <a-form-item class="f-item" label="所属街道巷编码" name="streetCode">
            <div v-if="isLook">{{ addForm.streetCode }}</div>
            <a-input v-else v-model:value="addForm.streetCode" placeholder="请输入所属街道巷编码" />
          </a-form-item>
          <a-form-item class="f-item" label="所属街道巷名称" name="streetName">
            <div v-if="isLook">{{ addForm.streetName }}</div>
            <a-input v-else v-model:value="addForm.streetName" placeholder="请输入所属街道巷名称" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24" class="row-box">
        <a-col :span="8">
          <a-form-item class="f-item" label="负责人姓名" name="masterName">
            <div v-if="isLook">{{ addForm.masterName }}</div>
            <a-input v-else v-model:value="addForm.masterName" placeholder="请输入负责人姓名" />
          </a-form-item>
          <a-form-item label="证件类型" name="masterCertType">
            <div v-if="isLook">{{ addForm.masterCertTypeName }}</div>
            <a-select v-else ref="select" v-model:value="addForm.masterCertType" style="width: 100%">
              <a-select-option v-for="item in idType" :key="item.id" :value="item.id">{{ item.name }} </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item class="f-item" label="负责人电话" name="masterMobile">
            <div v-if="isLook">{{ addForm.masterMobile }}</div>
            <a-input v-else v-model:value="addForm.masterMobile" placeholder="请输入负责人电话" />
          </a-form-item>
          <a-form-item label="所属民族" name="masternation">
            <div v-if="isLook">{{ addForm.masternationName }}</div>
            <a-select v-else ref="select" v-model:value="addForm.masternation" style="width: 100%">
              <a-select-option v-for="item in nation" :key="item.code" :value="item.code">{{ item.name }} </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item class="f-item" label="负责人身份证" name="masterCertNum">
            <div v-if="isLook">{{ addForm.masterCertNum }}</div>
            <a-input v-else v-model:value="addForm.masterCertNum" placeholder="请输入负责人身份证" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
import { createVNode, onMounted, reactive, toRefs, watch } from 'vue';
import { getSelectList, guotaiOperatorDel, guotaiOperatorDetail, guotaiOperatorEdit, guotaiOperatorList, guotaiOperatorSyn, houseDel, houseEdit, storeAdd } from '@/api/api';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { message, Modal } from 'ant-design-vue';
import useUtils from '@/hooks/useUtils.js'; //工具库
import AreaSelect from '@/components/pms/landlord/AreaSelect/AreaSelect.vue';
import StationSelect from '@/components/pms/landlord/AreaSelect/StationSelect.vue';
import store from '@/store/pms/landlord/index'; //VUEX
import router from '@/router/index';
import { baseRequestUrl } from '../../../../config.js';

export default {
  components: {
    // PlusOutlined,
    // CloseCircleOutlined,
    AreaSelect,
    StationSelect,
  },
  setup() {
    let { imgCut, countTable } = useUtils();

    // 搜索
    let search = reactive({
      topDom: '',
      searchForm: {
        store_name: '',
        status: [],
        start: 0,
        limit: store.getters.getPageSize,
      },
      searchLoading: false,
      // 重置
      handleReset() {
        search.searchForm.store_name = '';
        search.searchForm.status = [];
        table.getTableList();
      },
    });

    // 表格
    let table = reactive({
      editId: [],
      editSave(item) {
        houseEdit({
          hid: item.id,
          name: item.name,
        }).then(res => {
          message.success(res.msg);
          table.editId.splice(table.editId.indexOf(item.id), 1);
        });
      },
      tableHeight: '',
      dataSource: [],
      columns: [
        {
          title: '门店ID',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: '门店名称',
          dataIndex: 'realName',
          key: 'realName',
        },
        {
          title: '房间数',
          dataIndex: 'houseNum',
          key: 'houseNum',
        },
        {
          title: '联系人',
          dataIndex: 'masterName',
          key: 'masterName',
          width: 160,
          customRender({ record }) {
            return record.masterName + '_' + record.masterMobile;
          },
        },
        {
          title: '地址',
          dataIndex: 'hotelAddress',
          key: 'hotelAddress',
          width: 200,
          customRender({ record }) {
            return record.province_name + record.city_name + record.area_name + record.hotelAddress;
          },
          ellipsis: true,
        },
        {
          title: '所属派出所',
          dataIndex: 'policeAreaName',
          key: 'policeAreaName',
          width: 150,
        },
        {
          title: '状态',
          dataIndex: 'status_text',
          key: 'status_text',
        },
        {
          title: '苏州公安上报状态',
          dataIndex: 'szga_report_status',
          key: 'szga_report_status',
          width: 150,
          customRender({ record }) {
            const statusMap = {
              0: '待上报',
              1: '上报中',
              2: '上报成功',
              3: '上报失败',
            };
            return statusMap[record.szga_report_status] ?? record.szga_report_status_text ?? '-';
          },
        },
        {
          title: '备注',
          dataIndex: 'remark',
          key: 'remark',
          ellipsis: true,
          width: 150,
        },
        {
          title: '是否注销',
          dataIndex: 'cancelState',
          key: 'cancelState',
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          key: 'create_time',
          width: 160,
        },
        {
          title: '',
          dataIndex: 'operate',
          key: 'operate',
          width: 250,
        },
      ],
      companyLogo: JSON.parse(sessionStorage.getItem('companyInfo') || '{}').logo || '',
      getTableList() {
        search.searchLoading = true;
        guotaiOperatorList({
          store_name: search.searchForm.store_name,
          start: search.searchForm.start,
          limit: search.searchForm.limit,
          status: search.searchForm.status.toString(),
        })
          .then(res => {
            table.dataSource = res.data.list;
            pagination.pageTotal = res.data.count;
            search.searchLoading = false;
          })
          .catch(() => {
            search.searchLoading = false;
          });
      },
      goRouter(url, params = {}, tab = 1) {
        router.push({ path: url, query: { hid: params.id, tab: tab } });
      },
    });

    // 弹窗
    let modal = reactive({
      areaPlaceholder: '请选择区域',
      stationPlaceholder: '请选择派出所',
      formTitle: '添加门店',
      visibleRoom: false,
      visibleAdd: false,
      visibleJoin: false,
      CompanyOta: [],
      loading: false,
      // 上传
      uploadLoading: false,
      action: baseRequestUrl + '/h5/upload/uploadImg' + '?info=' + JSON.parse(sessionStorage.getItem('landlordInfo')).info,
      header: {
        token: JSON.parse(sessionStorage.getItem('landlordInfo')).token,
        version: '1.0.0',
        source: '1',
      },
      formData: {
        module: 'pms',
        type: 'logo',
      },
      idType: [],
      nation: [],

      isLook: false,

      //  上传图片
      uploadFinally(info, key) {
        if (info.file.status === 'done') {
          modal.addForm[key] = info.file.response.data.url;
        }
      },
      getInitData() {
        return {
          hotelCode: '',
          businessLicense: '',
          hotelName: '',
          realName: '',
          hotelAddress: '',
          houseNum: '',
          ty_roomAddress: '',
          province_id: '',
          city_id: '',
          area_id: '',
          province_name: '',
          city_name: '',
          area_name: '',
          districtCode: '',
          districtName: '',
          policeAreaCode: '',
          policeAreaName: '',
          streetCode: '',
          streetName: '',
          cancelState: '',
          cancelTime: '',
          masterCertNum: '',
          masterCertType: '',
          masterMobile: '',
          masterName: '',
          masternation: '',
          masternationName: '',
          masterCertTypeName: '',
          id: '',
        };
      },
      special_date: '',
      company_date: '',
      updateDateChange(_, dateString) {
        modal.addForm.special_date = dateString;
      },
      updateDateChange1(_, dateString) {
        modal.addForm.company_date = dateString;
      },
      getSelectList() {
        getSelectList({}).then(res => {
          modal.idType = res.data.id_type;
          modal.nation = res.data.nation;
        });
      },

      // 打开添加门店
      openAddStore() {
        modal.isLook = false;
        modal.areaPlaceholder = '请选择区域';
        modal.formTitle = '添加门店';
        modal.addForm = modal.getInitData();
        modal.visibleAdd = true;
      },
      // 查看门店
      openDetails(e, type) {
        if (type == 1) {
          modal.isLook = true;
          modal.formTitle = '查看门店';
        } else {
          modal.isLook = false;
          modal.formTitle = '编辑门店';
        }
        modal.addForm = modal.getInitData();
        modal.visibleAdd = true;
        guotaiOperatorDetail({
          id: e.id,
        }).then(res => {
          Object.keys(modal.addForm).forEach(i => {
            modal.addForm[i] = res.data[i];
          });
          modal.addForm.id = res.data.id;
          modal.addForm.status = res.data.status;
          modal.areaPlaceholder = res.data.province_name + ' / ' + res.data.city_name + ' / ' + res.data.area_name;
          modal.stationPlaceholder = res.data.policeAreaName;
        });
      },
      operSyn(e) {
        Modal.confirm({
          title: `是否同步上报数据？`,
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            guotaiOperatorSyn({
              id: e.id,
            })
              .then(res => {
                message.success(res.msg);
                modal.modalLoading = false;
                table.getTableList();
              })
              .catch(() => {
                modal.modalLoading = false;
              });
          },
        });
      },
      cancel(e) {
        Modal.confirm({
          title: `是否注销？`,
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            guotaiOperatorDel({
              id: e.id,
            })
              .then(res => {
                message.success(res.msg);
                modal.modalLoading = false;
                table.getTableList();
              })
              .catch(() => {
                modal.modalLoading = false;
              });
          },
        });
      },
      rowData: '',
      addForm: {},
      formRef: '', //表单验证

      modalLoading: false,
      //确定
      confirmFun() {
        if (modal.addForm.id && modal.addForm.id > 0 && modal.isLook === false) {
          modal.handleEditSave();
        } else {
          modal.visibleAdd = false;
        }
      },
      // 新增
      handleAddSave() {
        if (modal.modalLoading) {
          return;
        }
        modal.formRef.validate().then(() => {
          modal.modalLoading = true;
          storeAdd(modal.addForm)
            .then(res => {
              message.success(res.msg);
              modal.visibleAdd = false;
              table.getTableList();
              modal.modalLoading = false;
            })
            .catch(() => {
              modal.modalLoading = false;
            });
        });
      },
      //编辑
      handleEditSave() {
        if (modal.modalLoading) {
          return;
        }
        modal.formRef.validate().then(() => {
          modal.modalLoading = true;
          guotaiOperatorEdit(modal.addForm)
            .then(res => {
              message.success(res.msg);
              modal.visibleAdd = false;
              table.getTableList();
              modal.modalLoading = false;
            })
            .catch(() => {
              modal.modalLoading = false;
            });
        });
      },
      // 选择区域回调
      changeArea(params) {
        console.log('333333', params);
        Object.assign(modal.addForm, params);
      },
      // 选择派出所回调
      changeStation(params) {
        console.log('22222', params);
        // Object.assign(modal.addForm, params);
        modal.addForm.policeAreaCode = params.a_code;
        modal.addForm.policeAreaName = params.a_name;
      },

      // 删除账号
      handleDel(item) {
        Modal.confirm({
          title: '确定移除此房间？',
          content: '删除房间后，您房间的房态将被删除并无法恢复；房间的订单在订单列表中仍然可被检索，但其将不属于任何一个房间，除非手动换房，否则无法在房态日历中显示；历史统计数据不受影响。',
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            houseDel({ hid: item.id }).then(res => {
              message.success(res.msg);
              table.getTableList();
            });
          },
        });
      },
    });

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        table.getTableList();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        table.getTableList();
      },
    });

    watch(
      () => store.state.ContentHeight,
      () => {
        table.tableHeight = countTable(search.topDom) - 80;
      }
    );

    onMounted(() => {
      table.getTableList();
      table.tableHeight = countTable(search.topDom) - 80;
      modal.getSelectList();
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(modal),
      ...toRefs(pagination),
      imgCut,
    };
  },
};
</script>

<style lang="scss" scoped>
.row-box {
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 20px;

  .f-item {
    margin-bottom: 10px !important;
  }
}

:deep(.areaSel) {
  input::-webkit-input-placeholder {
    color: #262626;
  }

  input:-ms-input-placeholder {
    // IE 10 +
    color: #262626;
  }

  input:-moz-placeholder {
    // Firefox 4 -18
    color: #262626;
  }

  input::-moz-placeholder {
    // Firefox 19 +
    color: #262626;
  }
}
</style>
